var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1010_3233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0833 2.99998H6.41667C6.30616 2.99998 6.20018 3.04388 6.12204 3.12202C6.0439 3.20016 6 3.30614 6 3.41665V5.49998H3.91667C3.80616 5.49998 3.70018 5.54388 3.62204 5.62202C3.5439 5.70016 3.5 5.80614 3.5 5.91665V12.5833C3.5 12.6938 3.5439 12.7998 3.62204 12.8779C3.70018 12.9561 3.80616 13 3.91667 13H10.5833C10.6938 13 10.7998 12.9561 10.878 12.8779C10.9561 12.7998 11 12.6938 11 12.5833V10.5H13.0833C13.1938 10.5 13.2998 10.4561 13.378 10.3779C13.4561 10.2998 13.5 10.1938 13.5 10.0833V3.41665C13.5 3.30614 13.4561 3.20016 13.378 3.12202C13.2998 3.04388 13.1938 2.99998 13.0833 2.99998ZM10.1667 12.1666H4.33333V6.33331H10.1667V12.1666ZM12.6667 9.66665H11V5.91665C11 5.80614 10.9561 5.70016 10.878 5.62202C10.7998 5.54388 10.6938 5.49998 10.5833 5.49998H6.83333V3.83331H12.6667V9.66665Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1010_3233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.6667,
    height: 10.6667,
    fill: "white",
    transform: "translate(3.16675 2.66667)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.1d9f12dbc39804ee68c7b7bc9c22f577.svg";
export { ForwardRef as ReactComponent };